import { Check, Handshake } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { EXISTING_POINTS } from "@/lib/pricing";

/**
 * Karte „Bestehende Sponsorings mitbringen“ für Vereins- und
 * Unternehmensseite. Die Regel steht in src/lib/pricing.js, Überschrift und
 * Text formuliert jede Seite für ihre Zielgruppe.
 */
export const ExistingSponsorship = ({ title, text, className = "" }) => (
  <Reveal className={className} delay={0.1}>
    <div
      data-testid="existing-sponsorship"
      className="relative overflow-hidden rounded-3xl border border-white/10 backdrop-blur-xl p-8 md:p-10"
    >
      <div className="pointer-events-none absolute -top-24 -right-16 w-80 h-80 rounded-full bg-brand-orange/15 blur-[110px]" />
      <div className="relative flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-14">
        <div className="flex flex-col sm:flex-row gap-5 lg:flex-1">
          <span className="flex items-center justify-center w-12 h-12 shrink-0 rounded-xl bg-white/[0.06] border border-white/10">
            <Handshake className="w-5 h-5 text-brand-orange" />
          </span>
          <div>
            <span className="block text-[11px] uppercase tracking-[0.2em] font-bold text-white/40 mb-2">
              Bestehende Sponsorings
            </span>
            <h3 className="font-display font-bold text-2xl md:text-3xl text-white mb-3">
              {title}
            </h3>
            <p className="max-w-3xl text-base leading-relaxed text-white/60">
              {text}
            </p>
          </div>
        </div>
        <ul className="flex flex-wrap lg:flex-col gap-2.5 lg:w-64 shrink-0">
          {EXISTING_POINTS.map((point) => (
            <li
              key={point}
              className="inline-flex items-center gap-2.5 rounded-full border border-white/12 bg-white/[0.03] px-4 py-2 text-sm font-semibold text-white/80"
            >
              <Check className="w-4 h-4 shrink-0 text-brand-orange" />
              {point}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </Reveal>
);
